import { useMemo } from "react";

import { useAppSelector } from "@js/hooks";
import type { EmployerBidListBid } from "@js/types/jobs";

import {
  canBeInterviewed,
  getSelectedBidIds,
} from "../../components/bulk-select-actions/bid-bulk-selection-slice";

export const useSelectedInterviewableBids = (bidList: EmployerBidListBid[]) => {
  const selectedBidIds = useAppSelector(getSelectedBidIds);
  const selectedInterviewableBids = useMemo(
    () =>
      bidList.filter(
        (bid) => selectedBidIds.includes(bid.id) && canBeInterviewed(bid),
      ),
    [bidList, selectedBidIds],
  );

  return { selectedInterviewableBids };
};
